import { createCss } from '@stitches/react';
import "@fontsource/benne";
import "@fontsource/lato";
import "@fontsource/cardo";
import "@fontsource/cardo/400-italic.css";

export const { styled, css, getCssString } = createCss({
    theme: {
      colors: {
        colorBorder: '#d3dce2',
        colorGrey: '#7e8999',
        colorPurple: '#b400ff',
        colorDarkBg: '#191919',
      },
      fonts: {
        default: 'Benne',
        lato: 'Lato',
        cardo: 'Cardo',
      },
      fontSizes: {
        smallCopy: '14px',
        normalCopy: '16px',
      },
      lineHeights: {
        normalLineHeight: '28px',
      }
    },
    media: {
      bp1: '(max-width: 600px)',
      bp2: '(min-width: 600px)',
      bp3: '(min-width: 1280px)',
      bp4: '(min-width: 1068px)',
    },
  });
